import { Inject, Input, OnChanges, SimpleChanges, Directive } from '@angular/core';
import { AnalyticsChartService } from './analytics-chart.service';
import { AnalyticsGraphFormat } from '../analytics.interfaces';

@Directive()
export abstract class AnalyticsChartComponent implements OnChanges {
  @Input() graphData: any;
  @Input() labels?: string[];
  @Input() statValue: string;
  @Input() statFormat: AnalyticsGraphFormat;

  graphOptions: any;
  formattedStatValue: string;
  hasData: boolean;

  constructor(
    @Inject(AnalyticsChartService)
    protected analyticsChartService: AnalyticsChartService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    /* tslint:disable:no-string-literal */
    if (changes['graphData'] || changes['statValue']) {
      this.renderGraph();
    }
    /* tslint:enable:no-string-literal */
  }

  renderGraph(): void {
    this.getOptions();
    this.hasData = this.analyticsChartService.hasData(this.graphData);
    this.formattedStatValue = this.analyticsChartService.formatStatValue(this.statValue, this.statFormat);
  }

  getOptions(): void {
    this.graphOptions = {
      chart: {},
      title: { text: null },
      labels: { enabled: false },
      credits: { enabled: false },
    };
  }
}
